import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";
import { addAmin } from "../redux/adminSlice";

const baseURL = import.meta.env.VITE_Backend_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSuccessfulAuth = async (token) => {
    try {
      const response = await axios.get(`${baseURL}/api/admin/verify-sso`, {
        headers: {
          "Authorization": `Bearer ${token}`
        },
      });

      if (response.status === 200) {
        const userData = response.data.admin;
        dispatch(addAmin(userData));
        localStorage.setItem("lsh-token", token);
        toast.success("Login Successful via SSO");
        navigate("/admin/UltimateHoldingCompany");
      } else {
        throw new Error(response.data.message || "Failed to verify user");
      }
    } catch (error) {
      console.error("Authentication error:", error);
      
      // Handle specific error cases from backend
      if (error.response) {
        const { status, data } = error.response;
        
        switch(status) {
          case 401:
            if (data.message.includes("verification")) {
              navigate(`/login-error?error=account_not_verified&message=${encodeURIComponent(data.message)}`);
            } else if (data.message.includes("business group")) {
              navigate(`/login-error?error=no_business_group&message=${encodeURIComponent(data.message)}`);
            } else {
              navigate(`/login-error?error=auth_failed&message=${encodeURIComponent(data.message || "Authentication failed")}`);
            }
            break;
          case 403:
            navigate(`/login-error?error=session_expired&message=${encodeURIComponent(data.message || "Session expired")}`);
            break;
          case 404:
            navigate(`/login-error?error=user_not_found&message=${encodeURIComponent(data.message || "User not found")}`);
            break;
          default:
            navigate(`/login-error?error=auth_failed&message=${encodeURIComponent(data.message || "Authentication failed")}`);
        }
      } else {
        navigate(`/login-error?error=network_error&message=${encodeURIComponent(error.message || "Network error occurred")}`);
      }
    }
  };

  useEffect(() => {
    const processAuthCallback = async () => {
      try {
        const hash = window.location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const token = params.get("token");

        if (token) {
          await handleSuccessfulAuth(token);
        } else {
          // Check for error in query parameters
          const queryParams = new URLSearchParams(window.location.search);
          const error = queryParams.get("error");
          const errorMessage = queryParams.get("message");

          if (error) {
            navigate(`/login-error?error=${error}${errorMessage ? `&message=${encodeURIComponent(errorMessage)}` : ''}`);
          } else {
            navigate('/login-error?error=no_token&message=No authentication token received');
          }
        }
      } catch (error) {
        console.error("Error processing auth callback:", error);
        navigate('/login-error?error=unexpected_error&message=An unexpected error occurred during authentication');
      }
    };

    processAuthCallback();
  }, [navigate, dispatch]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mx-auto mb-4"></div>
        <p className="text-lg font-medium text-gray-700">
          Authenticating with Azure AD...
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;